module.exports = __webpack_public_path__ + "static/media/giscake-background.84c935c0.jpg";